import { Link, NavLink, useLocation } from "react-router-dom";
import { assets } from "../../Assets/assets";
import { FaChevronDown } from "react-icons/fa6";
import { useEffect, useRef, useState } from "react";
import HamburgerButton from "./HamburgerButton";
import { AnimatePresence, motion } from "framer-motion";
import CloseButton from "./CloseButton";
import { IoMdMail } from "react-icons/io";
import services from "../../config/services.json"
import itServices from "../../config/itServices.json"

const MainNavbar = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const menuRef = useRef(null);

  const menuItems = [
    { name: "Home", link: "/" },

    {
      name: "About Us",
      activePath: "/aboutus",
      dropdown: [
        { name: "About Natio", link: "/aboutus#about-natio" },
        { name: "Mission & Vision", link: "/aboutus#mission-vision" },
        // { name: "Our expert team", link: "/aboutus#our-expert-team" },
        { name: "Core Principles", link: "/aboutus#core-principles" },
        { name: "Natio Advantages", link: "/aboutus#natio-advantages" },
        { name: "Our Approach", link: "/aboutus#our-approach" },
      ],
    },
    {
      name: "Services",
      activePath: "/service",
      dropdown: services.map((s) => ({
        name: s.title,
        link: `/service/${s.id}`
      })),
    },
    {
      name: "IT Solutions",
      activePath: "/itsolutions",
      dropdown: itServices.map((s) => ({
        name: s.servieName,
        link: `/itsolutions/${s.id}`
      })),
    },
    { name: "Career", link: "/career" },
    { name: "Blog", link: "/blog" },
    { name: "Contact Us", link: "/contactus" },
  ];


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!menuOpen) setActiveDropdown(null);
  }, [menuOpen]);


  return (
    <header className="bg-white w-full z-50">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 xl:py-4 py-3">
        <Link to={"/"}>
          <img src={assets.navlogo} alt="Logo" className="h-12" />
        </Link>

        <ul className="hidden lg:flex items-center gap-10 text-lg">
          {menuItems.map((item, index) => {
            const isParentActive =
              item.activePath && pathname.startsWith(item.activePath);

            return (
              <li key={index} className="relative group cursor-pointer">
                {item.dropdown ? (
                  <div data-aos="fade-down" data-aos-delay={`${index * 100}`}
                    className={`transition-colors duration-300 hover:text-primaryColor flex items-center gap-1 ${isParentActive
                      ? "text-primaryColor font-medium"
                      : "text-secondaryTextColor"
                      }`}
                  >
                    {item.name}
                    <FaChevronDown
                      size={16}
                      className={`transition duration-300 ${isParentActive ? "rotate-180" : "group-hover:rotate-180"
                        }`}
                    />
                  </div>
                ) : (
                  <NavLink data-aos="fade-down" data-aos-delay={`${index * 100}`}
                    end
                    className={({ isActive }) =>
                      `${isActive
                        ? "text-primaryColor font-medium"
                        : "text-secondaryTextColor"
                      } transition-colors duration-300 inline-block hover:text-primaryColor`
                    }
                    to={item.link}
                  >
                    {item.name}
                  </NavLink>
                )}

                <span
                  className={`absolute left-0 -bottom-1 h-[3px] bg-gradient-to-tr from-primaryColor to-primaryFadedColor transition-all duration-300 ${isParentActive ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                ></span>

                {item.dropdown && (
                  <ul className="absolute left-0 mt-3 w-56 p-3 bg-white shadow-md rounded-lg overflow-hidden border scale-95 opacity-0 invisible group-hover:visible group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 origin-top">
                    {item.dropdown.map((sub, i) => (
                      <li key={i}>
                        <NavLink
                          end
                          to={sub.link}
                          className={({ isActive }) =>
                            `block px-4 py-2 text-sm hover:bg-[#DBE3EA] hover:text-primaryColor rounded-md transition-colors duration-300 ${isActive
                              ? "text-secondaryTextColor"
                              : "text-secondaryTextColor"
                            }`
                          }
                        >
                          {sub.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>

        <div className="lg:hidden block">
          <HamburgerButton
            isOpen={menuOpen}
            onClick={() => setMenuOpen(true)}
          />
        </div>
      </div>

      <div
        className={`bg-primaryFadedColor/20 transition-all duration-500 backdrop-blur-sm ${menuOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          } w-full h-screen fixed top-0`}
      ></div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            ref={menuRef}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.35, ease: "easeInOut" }}
            className="fixed top-0 right-0 w-3/4 sm:w-1/2 h-full bg-white shadow-lg z-50 px-6 pb-6 flex flex-col overflow-y-auto"
          >
            <div className="flex items-center sticky top-0 bg-white justify-between mb-6 py-6 z-50">
              <img src={assets.navlogo} className="h-10" alt="Logo" />
              <CloseButton onClick={() => setMenuOpen(false)} />
            </div>

            <div className="flex flex-col gap-4">
              {menuItems.map((item, index) => {
                const hasDropdown = !!item.dropdown;
                const isParentActive = pathname.startsWith(item.activePath);

                return (
                  <div key={index} className="border-b pb-2">
                    <div
                      onClick={() =>
                        hasDropdown
                          ? setActiveDropdown(
                            activeDropdown === index ? null : index
                          )
                          : setMenuOpen(false)
                      }
                      className="flex justify-between items-center text-[17px] font-medium cursor-pointer"
                    >
                      {hasDropdown ? (
                        <span
                          className={`${isParentActive
                            ? "text-primaryColor"
                            : "text-secondaryTextColor"
                            }`}
                        >
                          {item.name}
                        </span>
                      ) : (
                        <NavLink
                          end
                          to={item.link}
                          onClick={() => setMenuOpen(false)}
                          className={({ isActive }) =>
                            `${isActive
                              ? "text-primaryColor font-semibold"
                              : "text-secondaryTextColor"
                            } w-full`
                          }
                        >
                          {item.name}
                        </NavLink>
                      )}

                      {hasDropdown && (
                        <motion.div
                          initial={false}
                          animate={{
                            rotate: activeDropdown === index ? 180 : 0,
                          }}
                          transition={{ duration: 0.3 }}
                        >
                          <FaChevronDown />
                        </motion.div>
                      )}
                    </div>

                    <AnimatePresence>
                      {activeDropdown === index && hasDropdown && (
                        <motion.ul
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.25, ease: "easeInOut" }}
                          className="pl-4 mt-3 flex flex-col gap-2"
                        >
                          {item.dropdown.map((sub, i) => (
                            <li key={i}>
                              <NavLink
                                end
                                to={sub.link}
                                onClick={() => setMenuOpen(false)}
                                className={({ isActive }) =>
                                  `block text-[15px] px-2 py-2 rounded-md transition ${isActive
                                    ? "text-secondaryTextColor font-semibold"
                                    : "text-secondaryTextColor hover:bg-gray-100 hover:text-primaryColor"
                                  }`
                                }
                              >
                                {sub.name}
                              </NavLink>
                            </li>
                          ))}
                        </motion.ul>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
            </div>

            <div className="bg-primaryFadedColor text-sm rounded-lg text-center mt-3 text-white font-extralight">
              <article className="p-3">
                <h1 className="hidden md:block">
                  "Smart Staffing for a Smarter Tomorrow"
                </h1>
                <h1 className="flex text-xs md:text-balance flex-col md:flex-row items-center justify-center gap-1">
                  <IoMdMail className="text-2xl" />
                  natiomanagement@gmail.com
                </h1>
              </article>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default MainNavbar;